"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var bleedContainerStyles_1 = require("./bleedContainerStyles");
var clsx_1 = require("clsx");
var BleedContainer = function (_a) {
    var _b;
    var children = _a.children, props = __rest(_a, ["children"]);
    var style = bleedContainerStyles_1.default();
    var classes = props.classes;
    return (<core_1.Container className={clsx_1.default([style.root, (_b = classes) === null || _b === void 0 ? void 0 : _b.root])} {...props}>
      {children}
    </core_1.Container>);
};
exports.default = BleedContainer;
